import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDropDownArrow = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z",
			fill: "#EDFAF4",
			stroke: "#03A65B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.7278 10.8083C14.9426 10.5935 15.2908 10.5935 15.5056 10.8083C15.7204 11.0231 15.7204 11.3713 15.5056 11.5861L12.2719 14.8198L9.03823 11.5861C8.82344 11.3713 8.82344 11.0231 9.03823 10.8083C9.25302 10.5935 9.60126 10.5935 9.81604 10.8083L12.2719 13.2641L14.7278 10.8083Z",
			fill: "#03A65B"
		})
	]
});
const ForwardRef = forwardRef(SvgDropDownArrow);
export default ForwardRef;
